import { MenuItem } from '@fountain/fountain-ui-components';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { isCurrentPageMatch } from '../../helpers';
import makeStyles from './styles';

// Forwarded so MUI's Menu can attach refs to each child (Menu clones its
// children to wire up keyboard navigation). `partialMatch` and `viewable`
// are NavigationMenu-internal flags — destructure them out of the rest
// props so they don't end up as unknown attributes on the underlying <li>.
const NavigationMenuItem = React.forwardRef(function NavigationMenuItem(
  { message, partialMatch, viewable, to, ...props },
  ref,
) {
  const classes = makeStyles();

  const selected = to && isCurrentPageMatch(to, partialMatch);

  return (
    <MenuItem
      ref={ref}
      to={to}
      {...props}
      classes={{ root: classes.root, selected: classes.selected }}
      selected={selected}
      disabled={selected}
      className={classes.menuListItem}
    >
      <FormattedMessage {...message} />
    </MenuItem>
  );
});

NavigationMenuItem.propTypes = {
  to: PropTypes.string,
  partialMatch: PropTypes.bool,
  viewable: PropTypes.bool,
  message: PropTypes.object.isRequired,
  'data-testid': PropTypes.string.isRequired,
};

export default NavigationMenuItem;
